import {
  AssignmentOutlined,
  BarChartOutlined,
  BusinessOutlined,
  ExploreOutlined,
  HandshakeOutlined,
} from '@mui/icons-material';

import { globalConstants, RoutesEnum } from '@/shared/duck';

import { HeaderElementsType } from './types.ts';

export const HeaderElements: HeaderElementsType[] = [
  {
    title: globalConstants.PAGES.discover,
    to: RoutesEnum.Discover,
    icon: ExploreOutlined,
    isActive: true,
  },
  {
    title: globalConstants.PAGES.organizations,
    to: RoutesEnum.Organizations,
    icon: BusinessOutlined,
    isActive: true,
  },
  {
    title: globalConstants.PAGES.assessments,
    to: RoutesEnum.Assessments,
    icon: AssignmentOutlined,
    isActive: true,
  },
  {
    title: globalConstants.PAGES.agree,
    to: RoutesEnum.Agree,
    icon: HandshakeOutlined,
    isActive: true,
  },
  {
    title: globalConstants.PAGES.report,
    to: RoutesEnum.Report,
    icon: BarChartOutlined,
    isActive: true,
  },
]